import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { EventsLog } from '../EventsLog';
export var GlobalEventsLogs = /*#__PURE__*/function () {
  function GlobalEventsLogs(ttl) {
    _classCallCheck(this, GlobalEventsLogs);
    _defineProperty(this, "logs", new Map());
    _defineProperty(this, "defaultTtl", void 0);
    this.defaultTtl = ttl;
    this.createEventsLog('global');
  }
  _createClass(GlobalEventsLogs, [{
    key: "produce",
    value: function produce(topic, event) {
      var eventsLog = this.getEventsLog(topic);
      eventsLog.produce(event);
    }
  }, {
    key: "consume",
    value: function consume(topic, consumer) {
      var eventsLog = this.getEventsLog(topic);
      eventsLog.subscribe(consumer);
      consumer.tunnel(eventsLog);
      return function () {
        return eventsLog.unsubscribe(consumer);
      };
    }
  }, {
    key: "getEventsLog",
    value: function getEventsLog(topic) {
      var eventsLog = this.logs.get(topic);
      if (eventsLog) {
        return eventsLog;
      }
      this.createEventsLog(topic);
      return this.logs.get(topic);
    }
  }, {
    key: "createEventsLog",
    value: function createEventsLog(topic) {
      this.logs.set(topic, new EventsLog({
        topic: topic,
        ttl: this.defaultTtl
      }));
    }
  }]);
  return GlobalEventsLogs;
}();